/* KOYI Theme: Skript. Aus dem Prototyp übernommen und für Shopify angepasst. */
function sib(el,dir){ var w=el.closest(".shopify-section")||el; var s=dir<0?w.previousElementSibling:w.nextElementSibling; if(!s) return null; return s.classList.contains("shopify-section")?s.firstElementChild:s; }
/* ---------- Einblenden ---------- */
var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add("on");io.unobserve(e.target)}})},{threshold:.12});
function watch(){document.querySelectorAll(".rise:not(.on)").forEach(function(el){io.observe(el)})}
watch();



(function(){
  if(!("IntersectionObserver" in window)) return;
  var zio=new IntersectionObserver(function(es){
    es.forEach(function(e){
      if(!e.isIntersecting) return;
      zio.unobserve(e.target);
      var el=e.target, ziel=parseInt(el.dataset.zahl,10)||0, t0=null, dauer=1500;
      function schritt(t){ if(!t0) t0=t;
        var p=Math.min(1,(t-t0)/dauer), e2=1-Math.pow(1-p,3);
        el.textContent=Math.round(ziel*e2);
        if(p<1) requestAnimationFrame(schritt);
      }
      requestAnimationFrame(schritt);
    });
  },{threshold:.45});
  document.querySelectorAll("[data-zahl]").forEach(function(el){zio.observe(el)});
})();

/* ---------- Kopfzeile ---------- */
var kopfY=0;
function kopf(){
  var h=document.querySelector("header"); if(!h) return;
  var y=window.pageYOffset||0;
  var start=!document.body.classList.contains("hell");
  var hero=start?document.querySelector(".hero"):null;
  var grenze=hero?Math.max(40,hero.offsetHeight-90):10;
  h.classList.toggle("fest", !start || y>grenze);
  var mobOffen=document.getElementById("mob").classList.contains("on");
  if(mobOffen||y<=grenze+200||y<kopfY-4) h.classList.remove("weg");
  else if(y>kopfY+4) h.classList.add("weg");
  kopfY=y;
}
window.addEventListener("scroll",kopf,{passive:true});
window.addEventListener("resize",kopf);
kopf();



/* ---------- Altersnachweis ---------- */
var gate=document.getElementById("gate"); if(gate){
try{ if(localStorage.getItem("koyi-18")==="1") gate.classList.add("off"); }catch(e){}
document.getElementById("gateYes").onclick=function(){
  try{localStorage.setItem("koyi-18","1")}catch(e){}
  gate.classList.add("off"); tropfen(3);
};
document.getElementById("gateNo").onclick=function(){
  gate.querySelector(".box").innerHTML='<p class="kata" style="font-size:8px;color:var(--suna)">マイクロスピリット</p>'
   +'<h2 class="serif">Dann bis <em>später</em>.</h2>'
   +'<p>Kein Problem — wir sind auch in ein paar Jahren noch da. Bis dahin: Tonic pur ist auch nicht schlecht.</p>';
};
}

/* ---------- Kleine Spielerei 2: Was trinke ich heute? ---------- */
(function(){
  var btn=document.getElementById("wuerfel"); if(!btn) return;
  var out=document.getElementById("wuerfelOut");
  var karten=[].slice.call(document.querySelectorAll("#rezeptKarten .karte"));
  btn.onclick=function(){
    var runde=0, timer=setInterval(function(){
      karten.forEach(function(c,i){c.classList.toggle("hit", i===runde%karten.length)});
      runde++;
      if(runde>13){
        clearInterval(timer);
        var pick=Math.floor(Math.random()*karten.length);
        karten.forEach(function(c,i){c.classList.toggle("hit", i===pick)});
        var name=karten[pick].dataset.drink;
        out.textContent="Heute: "+name+". Das Eis liegt bereit.";
        karten[pick].scrollIntoView({behavior:"smooth",block:"center"});
        tropfen(2);
      }
    },90);
  };
})();


/* ---------- Der Tropfen ---------- */
function tropfen(n){
  for(var i=0;i<n;i++){
    (function(k){
      setTimeout(function(){
        var d=document.createElement("i");
        d.className="drip";
        d.style.left=(10+Math.random()*80)+"vw";
        d.style.animationDuration=(1.8+Math.random()*1.4)+"s";
        document.body.appendChild(d);
        setTimeout(function(){d.remove()},3600);
      },k*260);
    })(i);
  }
}
/* Dreimal auf die Wortmarke: ein Dash geht noch */
(function(){
  var n=0,t;
  var lg=document.getElementById("logo"); if(!lg) return;
  lg.addEventListener("click",function(ev){
    if(!(window.KOYI&&KOYI.tpl==="index")) return; ev.preventDefault();
    n++; clearTimeout(t); t=setTimeout(function(){n=0},900);
    if(n>=3){
      n=0; tropfen(6);
      var w=document.createElement("div");
      w.className="wink"; w.textContent="Ein Dash geht noch.";
      document.body.appendChild(w);
      setTimeout(function(){w.remove()},3600);
    } else if(n===1){ window.scrollTo({top:0,behavior:"smooth"}); }
  });
})();


/* ---------- Vergleich: Gleiches Glas, Prozentwert im Glas, Pipette ---------- */
(function(){
  var reihe=document.getElementById("vReihe"); if(!reihe) return;
  var HUB=0.7, ABV=0.70, ETH=HUB*ABV, REF_ML=16;
  var GLAS='<img src="'+((window.KOYI&&KOYI.assets&&KOYI.assets.icoGlas)||'')+'" alt="">';
  var pip=document.getElementById("vPip"), n=4, laeuft=false;
  var VOLT={3:"1,0",4:"1,3",5:"1,6"};
  function zeichne(){
    var N=Math.max(1,Math.round(REF_ML/(n*ETH))), eth=n*ETH, txt=VOLT[n]+"\u00a0%";
    var h=""; for(var i=0;i<N;i++) h+='<div class="vg" style="--gi:'+i+'">'+GLAS+'<div class="vp"><span class="vprz">'+txt+'</span></div></div>';
    reihe.innerHTML=h; var mobil=window.innerWidth<=820; reihe.style.setProperty("--cols",mobil?Math.min(N,4):(N>6?Math.ceil(N/2):N));
    document.getElementById("vN").textContent=N;
    document.getElementById("vn2").textContent=n;
    var lab=document.getElementById("vHubLabel"); lab.textContent=n+"\u00a0Dashes"; lab.classList.remove("neu"); void lab.offsetWidth; lab.classList.add("neu");
    document.getElementById("vPunkteTxt").textContent=txt;
    document.getElementById("vEthJe").textContent=eth.toFixed(1).replace(".",",");
    document.getElementById("vEthSumme").textContent=Math.round(N*eth);
  }
  pip.addEventListener("click",function(){
    if(laeuft) return; laeuft=true;
    var neu=(n>=5)?3:(n+1);
    var t=document.createElement("i"); t.className="vtr"; pip.appendChild(t);
    setTimeout(function(){ t.remove(); n=neu; zeichne(); laeuft=false; },560);
  });
  zeichne();
  var frage=document.querySelector(".vhubfrage"), hilfe=frage.parentElement;
  function zu(){ hilfe.classList.remove("offen"); frage.setAttribute("aria-expanded","false"); }
  function anpassen(){ var t=hilfe.querySelector(".vhubtip"); t.style.marginLeft="0"; var r=t.getBoundingClientRect(); var ueber=r.right-(window.innerWidth-12), unter=12-r.left; if(ueber>0) t.style.marginLeft=(-ueber)+"px"; else if(unter>0) t.style.marginLeft=unter+"px"; }
  hilfe.addEventListener("mouseenter",anpassen); frage.addEventListener("focus",anpassen);
  frage.addEventListener("click",function(e){ e.stopPropagation(); var o=hilfe.classList.toggle("offen"); frage.setAttribute("aria-expanded",o?"true":"false"); if(o) anpassen(); });
  document.addEventListener("click",zu);
  document.addEventListener("keydown",function(e){ if(e.key==="Escape") zu(); });
})();


/* ---------- Blatt-Übergänge ---------- */
["#tagesuhr","#tagesuhr + section",".herstell",".awards",".zahlen",".prodbuehne",".stimme.tief",".weiter"].forEach(function(sel){
  document.querySelectorAll(sel).forEach(function(el){ el.classList.add("blatt"); });
});
(function(){
  var tu=document.getElementById("tagesuhr"); if(tu){ var nx=sib(tu,1); if(nx) nx.classList.add("blatt"); }
  function luft(){
    document.querySelectorAll(".blatt").forEach(function(b){
      var v=sib(b,-1); if(!v||v.tagName!=="SECTION") return;
      v.classList.remove("vor-blatt"); v.style.removeProperty("--pb0");
      var pb=parseFloat(getComputedStyle(v).paddingBottom)||0;
      v.style.setProperty("--pb0",pb+"px"); v.classList.add("vor-blatt");
    });
  }
  luft(); var t; window.addEventListener("resize",function(){ clearTimeout(t); t=setTimeout(luft,150); });
})();


/* ---------- Weiche Kanten ---------- */
(function(){
  var K=[[".hero","u",4.8],[".prodbuehne","u",6],
         [".strip","o",5.5],["#verschenken","ou",5.5],
         [".breit","ou",5]];
  function bgOf(el){ while(el){ var c=getComputedStyle(el).backgroundColor; if(c&&c!=="rgba(0, 0, 0, 0)"&&c!=="transparent") return c; el=el.parentElement; } return "rgb(250,246,238)"; }
  function rgb(c){ return c.match(/[\d.]+/g).slice(0,3).join(","); }
  function kante(el,pos,col,h){ var s=document.createElement("span"); s.className="kante kante-"+pos; s.setAttribute("aria-hidden","true");
    s.style.setProperty("--kr",rgb(col)); s.style.setProperty("--kh",h+"rem"); el.appendChild(s); }
  K.forEach(function(k){ document.querySelectorAll(k[0]).forEach(function(el){
    el.classList.add("kante-host"); if(getComputedStyle(el).position==="static") el.style.position="relative";
    if(k[1].indexOf("o")>-1){ var p=sib(el,-1), c=bgOf(p||el.parentElement); var n3=c.match(/[\d.]+/g).slice(0,3).map(Number); var helligkeit=0.3*n3[0]+0.59*n3[1]+0.11*n3[2]; if(!(k[0]===".weiter"&&helligkeit<100)) kante(el,"o",c,k[2]); }
    if(k[1].indexOf("u")>-1){ var n=sib(el,1); kante(el,"u",bgOf(n||el.parentElement),k[2]); }
  }); });
})();


/* ---------- Rechner ---------- */
(function(){
  var HUB=0.7,ABV=0.70,GLAS=150,VERGLEICH=8;
  var KCAL_ETH=5.52;            /* kcal je ml reinem Alkohol: 0,789 g/ml x 7 kcal/g */
  var KCAL_FILLER=52.5;         /* 150 ml Tonic Water x 35 kcal je 100 ml */
  var KCAL_REF=16*KCAL_ETH+KCAL_FILLER;   /* 4 cl Gin (40 % vol) = 16 ml Alkohol + Tonic */
  var s=document.getElementById("hubs"); if(!s) return;
  function upd(){
    var n=+s.value, ml=n*HUB, vol=(ml*ABV)/GLAS*100;
    var kc=ml*ABV*KCAL_ETH+KCAL_FILLER, weniger=Math.round((1-kc/KCAL_REF)*100);
    document.getElementById("hCount").textContent=n;
    document.getElementById("oMl").textContent=ml.toFixed(1).replace(".",",")+" ml";
    document.getElementById("oDrinks30").textContent=Math.floor(30/ml);
    document.getElementById("oVol").textContent=vol.toFixed(1).replace(".",",")+" %";
    document.getElementById("oKcal").textContent=Math.round(kc)+" kcal";
    document.getElementById("oDrinks").textContent=Math.floor(100/ml);
    document.getElementById("barKoyi").style.width=Math.max(3,(vol/VERGLEICH)*100)+"%";
    document.getElementById("barKoyiTxt").textContent=vol.toFixed(1).replace(".",",")+" %";
    document.getElementById("barKcal").style.width=(kc/KCAL_REF*100)+"%";
    document.getElementById("barKcalTxt").textContent=Math.round(kc)+" kcal";
    document.getElementById("barKcalRef").textContent=Math.round(KCAL_REF)+" kcal";
    document.getElementById("kcalSatz").innerHTML=weniger+"\u00a0% weniger Kalorien als ein herkömmlicher Longdrink.";
    /* Ergebnisse neben dem Kreis */
    var vt=vol.toFixed(1).replace(".",",");
    var e=function(id){return document.getElementById(id)};
    if(e("eAlkVal")){
      e("eAlkRed").innerHTML=Math.round((1-vol/VERGLEICH)*100)+"\u00a0%";
      e("eAlkVal").innerHTML="ca.\u00a0"+vt+"\u00a0%";
      e("eAlkBar").style.width=Math.max(3,(vol/VERGLEICH)*100)+"%";
      e("eKcalRed").innerHTML=weniger+"\u00a0%";
      e("eKcalVal").innerHTML="ca.\u00a0"+Math.round(kc)+"\u00a0kcal";
      e("eKcalRef").innerHTML=Math.round(KCAL_REF)+"\u00a0kcal";
      e("eKcalBar").style.width=(kc/KCAL_REF*100)+"%";
      
    }
  }
  s.addEventListener("input",upd);upd();
})();


/* ---------- Das Glas als Regler ---------- */
(function(){
  var box=document.getElementById("enso"); if(!box) return;
  var glas=document.getElementById("grGlas"), fuell=document.getElementById("grFuell"), knopf=document.getElementById("grKnopf");
  var slider=document.getElementById("hubs"), zahl=document.getElementById("ensoZahl"), wort=document.getElementById("ensoWort");
  var HOEHE={3:24,4:42,5:60}, WORT={3:"leicht",4:"ausgewogen",5:"kr\u00e4ftig"}, MIN=16, MAX=68, BODEN=12;
  var lvl=0, wert=+slider.value, zieht=false, anim=null;
  function setze(h){ lvl=h; fuell.style.height=h+"%"; knopf.style.top=(100-BODEN-h)+"%"; }
  function laufe(ziel,dauer){
    cancelAnimationFrame(anim); var von=lvl,t0=null; dauer=dauer||520;
    function f(t){ if(!t0) t0=t; var p=Math.min(1,(t-t0)/dauer), e=1-Math.pow(1-p,3); setze(von+(ziel-von)*e); if(p<1) anim=requestAnimationFrame(f); }
    anim=requestAnimationFrame(f);
  }
  function anzeigen(n){
    zahl.textContent=n; wort.textContent=WORT[n];
    box.setAttribute("aria-valuenow",n); box.setAttribute("aria-valuetext",n+" Dashes, "+WORT[n]);
    box.querySelectorAll(".gr-marke").forEach(function(b){ b.classList.toggle("on",+b.dataset.n===n); });
  }
  function wertSetzen(n){
    n=Math.min(5,Math.max(3,n)); box.classList.add("benutzt");
    if(n!==wert){ wert=n; anzeigen(n); }
    if(+slider.value!==n){ slider.value=n; slider.dispatchEvent(new Event("input")); }
  }
  function hoehe(ev){
    var r=glas.getBoundingClientRect(); var f=(ev.clientY-r.top)/r.height*100;
    return Math.min(MAX,Math.max(MIN,100-BODEN-f));
  }
  function naechster(h){ var best=3,d=1e9; [3,4,5].forEach(function(n){ var dd=Math.abs(HOEHE[n]-h); if(dd<d){ d=dd; best=n; } }); return best; }
  box.addEventListener("pointerdown",function(ev){
    if(ev.target.closest(".gr-marke,.gr-pip")) return;
    zieht=true; try{ box.setPointerCapture(ev.pointerId); }catch(e){}
    cancelAnimationFrame(anim); var h=hoehe(ev); setze(h); wertSetzen(naechster(h)); ev.preventDefault();
  });
  box.addEventListener("pointermove",function(ev){ if(!zieht) return; var h=hoehe(ev); setze(h); wertSetzen(naechster(h)); });
  function los(){ if(!zieht) return; zieht=false; laufe(HOEHE[wert],420); }
  box.addEventListener("pointerup",los); box.addEventListener("pointercancel",los);
  box.querySelectorAll(".gr-marke").forEach(function(b){
    b.addEventListener("click",function(ev){ ev.stopPropagation(); var n=+b.dataset.n; wertSetzen(n); laufe(HOEHE[n]); });
  });
  box.addEventListener("keydown",function(ev){
    var k=ev.key, n=wert;
    if(k==="ArrowUp"||k==="ArrowRight") n++; else if(k==="ArrowDown"||k==="ArrowLeft") n--; else if(k==="Home") n=3; else if(k==="End") n=5; else return;
    ev.preventDefault(); n=Math.min(5,Math.max(3,n)); wertSetzen(n); laufe(HOEHE[n]);
  });
  slider.addEventListener("input",function(){ var n=+slider.value; if(n!==wert){ wert=n; anzeigen(n); laufe(HOEHE[n]); } });
  /* Pipette: ein Tipp = ein Dash mehr (3, 4, 5, dann wieder 3) */
  var pip=document.getElementById("grPip"), tropft=false;
  if(pip) pip.addEventListener("click",function(ev){
    ev.stopPropagation(); if(tropft) return; tropft=true;
    var neu=(wert>=5)?3:(wert+1);
    var pr=pip.getBoundingClientRect(), gr_=glas.getBoundingClientRect();
    var startY=pr.top+pr.height*0.92, flaecheY=gr_.top+gr_.height*(100-BODEN-lvl)/100;
    var t=document.createElement("i"); t.className="gr-tr"; t.style.setProperty("--fall",Math.max(30,flaecheY-startY)+"px"); pip.appendChild(t);
    setTimeout(function(){ t.remove(); wertSetzen(neu); laufe(HOEHE[neu],600); tropft=false; },560);
  });
  anzeigen(wert); setze(0);
  var gesehen=false;
  if(window.matchMedia("(prefers-reduced-motion: reduce)").matches){ setze(HOEHE[wert]); gesehen=true; box.classList.add("an"); }
  else{
    var io2=new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting&&!gesehen){ gesehen=true; box.classList.add("an"); laufe(HOEHE[wert],1300); io2.disconnect(); } }); },{threshold:.4});
    io2.observe(box);
  }
})();

/* ---------- Sanfter Parallax auf Bild- und Filmflächen ---------- */
(function(){
  if(window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
  var flaechen=[].slice.call(document.querySelectorAll(".film .media,.stage .set,.moment img"));
  var frame=0;
  function schieben(){
    frame=0;
    flaechen.forEach(function(el){
      var host=el.closest(".film,.stage,.moment"); if(!host) return;
      var r=host.getBoundingClientRect();
      if(r.bottom<-200||r.top>window.innerHeight+200) return;
      var mitte=(r.top+r.height/2-window.innerHeight/2)/window.innerHeight;
      el.style.transform="translate3d(0,"+(mitte*-26)+"px,0) scale(1.12)";
    });
  }
  window.addEventListener("scroll",function(){ if(!frame) frame=requestAnimationFrame(schieben); },{passive:true});
  window.addEventListener("resize",schieben);
  schieben();
})();



/* ---- Tagesuhr ---- */
(function(){
  var svg=document.querySelector(".tagesuhr .uhr"); if(!svg) return;
  var STD=[11,13,15,17,19,21,23];
  var TAGE=["Sonntag","Samstag","Samstag","Donnerstag","Freitag","Samstag","Sonntag"];
  var band=document.getElementById("tagesuhr"),
      zeiger=svg.querySelector(".uzeiger"),
      griff=svg.querySelector(".ugriff"),
      aZeit=document.getElementById("uZeit"),
      aTag=document.getElementById("uTag"),
      aJetzt=document.getElementById("uJetzt"),
      karten=[].slice.call(document.querySelectorAll(".mkarte2")),
      punkte=[].slice.call(document.querySelectorAll(".upunkt"));
  var i=4, echteStunde=null;

  /* Farbe des Himmels ueber den Tag: kuehler Vormittag, goldene Stunde, Nacht */
  var STOPS=[[11,58,74,82],[15,92,70,52],[17,107,66,42],[20,62,44,56],[23,23,50,63]];
  function himmel(h){
    var a=STOPS[0],b=STOPS[STOPS.length-1];
    for(var k=0;k<STOPS.length-1;k++){
      if(h>=STOPS[k][0]&&h<=STOPS[k+1][0]){a=STOPS[k];b=STOPS[k+1];break}
    }
    var t=(b[0]-a[0])?(h-a[0])/(b[0]-a[0]):0;
    function m(x,y){return Math.round(x+(y-x)*t)}
    return "rgb("+m(a[1],b[1])+","+m(a[2],b[2])+","+m(a[3],b[3])+")";
  }

  function zeichne(neu, sanft){
    i=(neu+STD.length)%STD.length;
    var h=STD[i], grad=h/24*360;
    zeiger.style.transform="rotate("+grad+"deg)";
    griff.style.transform="rotate("+grad+"deg)";
    aZeit.textContent=(h<10?"0":"")+h+":00";
    aTag.textContent=TAGE[i];
    band.style.setProperty("--himmel", himmel(h));
    svg.setAttribute("aria-valuenow", h);
    punkte.forEach(function(p,k){p.classList.toggle("an",k===i)});
    karten.forEach(function(c,k){
      if(k===i){ c.hidden=false; if(sanft!==false){ c.classList.remove("rein"); void c.offsetWidth; c.classList.add("rein"); } }
      else c.hidden=true;
    });
    merkeJetzt(h);
  }

  function merkeJetzt(h){
    if(echteStunde===null){aJetzt.innerHTML="&nbsp;";return}
    aJetzt.textContent = (echteStunde===h) ? "Gerade jetzt" : "\u00a0";
  }

  /* Winkel aus dem Zeigerpunkt, auf die naechste Stunde einrasten */
  function ausZeiger(e){
    var r=svg.getBoundingClientRect(),
        x=e.clientX-(r.left+r.width/2),
        y=e.clientY-(r.top+r.height/2);
    var grad=(Math.atan2(y,x)*180/Math.PI+90+360)%360;
    var std=grad/360*24;
    var beste=0,ab=99;
    STD.forEach(function(h,k){ var d=Math.abs(h-std); d=Math.min(d,24-d); if(d<ab){ab=d;beste=k} });
    return beste;
  }

  var zieht=false;
  function ab(e){ zieht=true; svg.classList.add("zieht"); svg.setPointerCapture&&svg.setPointerCapture(e.pointerId); bewege(e); }
  function bewege(e){ if(!zieht) return; var k=ausZeiger(e); if(k!==i) zeichne(k); }
  function auf(){ zieht=false; svg.classList.remove("zieht"); }
  svg.addEventListener("pointerdown",ab);
  svg.addEventListener("pointermove",bewege);
  svg.addEventListener("pointerup",auf);
  svg.addEventListener("pointercancel",auf);
  svg.addEventListener("keydown",function(e){
    if(e.key==="ArrowRight"||e.key==="ArrowUp"){e.preventDefault();zeichne(i+1)}
    if(e.key==="ArrowLeft"||e.key==="ArrowDown"){e.preventDefault();zeichne(i-1)}
  });
  punkte.forEach(function(p,k){ p.onclick=function(){zeichne(k)} });

  /* Beim Laden auf die echte Uhrzeit des Besuchers stellen */
  (function(){
    var jetzt=new Date(), h=jetzt.getHours();
    var beste=0,ab2=99;
    STD.forEach(function(s,k){ var d=Math.abs(s-h); if(d<ab2){ab2=d;beste=k} });
    echteStunde=STD[beste];
    zeichne(beste,false);
    aJetzt.textContent="Gerade jetzt";
  })();
})();


/* ---- Mitfliegender Kaufknopf ---- */
(function(){
  var leiste=document.getElementById("flieg"); if(!leiste) return;
  var weg=false, offen=false;

  var fz=document.getElementById("flZu"); if(fz) fz.onclick=function(){ weg=true; pruefe(); };

  function shopImBild(){
    var s=document.querySelector(".regal, .news");
    if(!s) return false;
    var r=s.getBoundingClientRect();
    return r.top < innerHeight*0.9 && r.bottom > 0;
  }
  function seite(){
    return (window.KOYI&&KOYI.tpl)||"";
  }

  function pruefe(){
    var korb=document.getElementById("cart");
    offen = korb && korb.classList.contains("on");
    var tor=document.getElementById("gate");
    var zu = tor && !tor.classList.contains("off");
    var zeigen = !weg && !offen && !zu
      && scrollY > innerHeight*1.15
      && seite()!=="cart"
      && !shopImBild();
    leiste.classList.toggle("an", !!zeigen);
    leiste.setAttribute("aria-hidden", zeigen?"false":"true");
  }

  var warte=false;
  addEventListener("scroll",function(){
    if(warte) return; warte=true;
    requestAnimationFrame(function(){ pruefe(); warte=false; });
  },{passive:true});
  addEventListener("resize",pruefe,{passive:true});
  /* Seitenwechsel und Korb beobachten */
  new MutationObserver(pruefe).observe(document.body,
    {attributes:true,subtree:true,attributeFilter:["class"]});
  pruefe();
})();


/* ===================== Shopify: Menü, Karten, Filter ===================== */
(function(){
  var burger=document.getElementById('burger'), mob=document.getElementById('mob');
  if(burger&&mob){ burger.addEventListener('click',function(){ var o=mob.classList.toggle('on'); burger.setAttribute('aria-expanded',o?'true':'false'); if(typeof kopf==='function') kopf(); }); }
  document.addEventListener('click',function(e){
    var k=e.target.closest('[data-href]'); if(!k) return;
    if(e.target.closest('a,button,input,select,textarea,label')) return;
    var u=k.getAttribute('data-href'); if(u) window.location.href=u;
  });
  document.addEventListener('keydown',function(e){
    if(e.key!=='Enter'&&e.key!==' ') return;
    var k=e.target.closest&&e.target.closest('[data-href]'); if(!k||e.target!==k) return;
    e.preventDefault(); var u=k.getAttribute('data-href'); if(u) window.location.href=u;
  });
  document.addEventListener('click',function(e){
    var b=e.target.closest('.jfilter button'); if(!b) return;
    var c=b.dataset.cat; b.parentElement.querySelectorAll('button').forEach(function(x){x.classList.toggle('on',x===b)});
    document.querySelectorAll('.jgrid .jkarte').forEach(function(k){k.hidden=!(c==='Alle'||k.dataset.cat===c)});
  });
  if(/customer_posted=true/.test(location.search)){
    var w=document.createElement('div'); w.className='wink'; w.textContent='Danke. Bitte bestätige die E-Mail, die wir dir geschickt haben.';
    document.body.appendChild(w); setTimeout(function(){w.remove()},4200); if(typeof tropfen==='function') tropfen(2);
  }
})();

/* ===================== Warenkorb (Shopify AJAX) ===================== */
var koyiMoney;
(function(){
  var K=window.KOYI||{routes:{cartAdd:'/cart/add',cartChange:'/cart/change',cartUpdate:'/cart/update',cart:'/cart',cartJs:'/cart.js'}};
  var cartEl=document.getElementById('cart'), scrim=document.getElementById('scrim');
  function fmt(c){ try{ return (c/100).toLocaleString(K.locale||'de-DE',{style:'currency',currency:K.currency||'EUR'}); }catch(e){ return (c/100).toFixed(2).replace('.',',')+' €'; } }
  koyiMoney=fmt;
  window.openCart=function(){ if(!cartEl) return; cartEl.classList.add('on'); cartEl.setAttribute('aria-hidden','false'); if(scrim) scrim.classList.add('on'); };
  window.closeCart=function(){ if(!cartEl) return; cartEl.classList.remove('on'); cartEl.setAttribute('aria-hidden','true'); if(scrim) scrim.classList.remove('on'); };
  function holen(){ return fetch(K.routes.cartJs,{headers:{Accept:'application/json'}}).then(function(r){return r.json()}); }
  function el(tag,cls,txt){ var e=document.createElement(tag); if(cls) e.className=cls; if(txt!=null) e.textContent=txt; return e; }
  function zeichne(c){
    var badge=document.getElementById('badge'); if(badge){ badge.style.display=c.item_count?'flex':'none'; badge.textContent=c.item_count; }
    var cc=document.getElementById('ccount'); if(cc) cc.textContent=c.item_count+' Artikel';
    var cs=document.getElementById('csum'); if(cs) cs.textContent=fmt(c.total_price);
    var sh=document.getElementById('cship');
    if(sh){
      var gr=+sh.getAttribute('data-grenze')||0;
      if(!gr||!c.items.length){ sh.hidden=true; }
      else {
        sh.hidden=false;
        var rest=gr-c.total_price, hi=document.getElementById('cshint'), fl=document.getElementById('csfill'), upEl=document.getElementById('csup');
        if(fl) fl.style.width=Math.max(0,Math.min(100,Math.round(c.total_price/gr*100)))+'%';
        if(hi) hi.textContent=rest>0?('Noch '+fmt(rest)+' bis zum Gratisversand.'):'Der Versand ist bei dir kostenlos.';
        sh.classList.toggle('ok',rest<=0);
        if(upEl){
          var upId=+upEl.getAttribute('data-pid'), upPreis=+upEl.getAttribute('data-preis');
          var schonDrin=c.items.some(function(it){ return it.product_id===upId; });
          upEl.hidden=!(rest>0&&upPreis>=rest&&!schonDrin);
        }
      }
    }
    var box=document.getElementById('clines'); if(!box) return; box.innerHTML='';
    if(!c.items.length){ var p=el('p','leer'); p.innerHTML='Noch nichts drin.<br>Drei Dashes fehlen zum Feierabend.'; box.appendChild(p); return; }
    c.items.forEach(function(it){
      var ln=el('div','ln'); var img=el('img'); img.alt=''; img.width=44; img.height=62;
      var src=(it.featured_image&&it.featured_image.url)||it.image||''; img.src=src; ln.appendChild(img);
      var mid=el('div'); mid.style.flex='1';
      var t=el('p','serif'); t.style.fontSize='1.15rem'; var a=el('a',null,it.product_title); a.href=it.url; t.appendChild(a); mid.appendChild(t);
      var vt=(it.variant_title&&it.variant_title!=='Default Title')?it.variant_title:''; if(vt){ var v=el('p',null,vt); v.style.cssText='font-size:.72rem;color:rgba(28,27,25,.68);margin-top:.15rem'; mid.appendChild(v); }
      var q=el('div','qty'); var m=el('button',null,'−'); m.type='button'; m.setAttribute('aria-label','Weniger'); m.dataset.key=it.key; m.dataset.q=it.quantity-1;
      var n=el('span',null,it.quantity); n.style.cssText='min-width:1.4rem;text-align:center;font-size:.8rem';
      var pl=el('button',null,'+'); pl.type='button'; pl.setAttribute('aria-label','Mehr'); pl.dataset.key=it.key; pl.dataset.q=it.quantity+1;
      q.appendChild(m); q.appendChild(n); q.appendChild(pl); mid.appendChild(q); ln.appendChild(mid);
      var pr=el('p',null,fmt(it.final_line_price)); pr.style.fontSize='.85rem'; ln.appendChild(pr); box.appendChild(ln);
    });
  }
  window.koyiCartRender=zeichne;
  function aendern(key,q){ return fetch(K.routes.cartChange+'.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:key,quantity:q})}).then(function(r){return r.json()}).then(zeichne); }
  window.addToCart=function(id,qty,btn){
    var alt=btn?btn.textContent:''; if(btn){ btn.disabled=true; }
    return fetch(K.routes.cartAdd+'.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:+id,quantity:qty||1}]})})
      .then(function(r){ if(!r.ok) throw r; return r.json(); }).then(holen).then(function(c){ zeichne(c); window.openCart(); if(typeof tropfen==='function') tropfen(1); })
      .catch(function(){ window.location.href=K.routes.cart; })
      .then(function(){ if(btn){ btn.disabled=false; } });
  };
  document.addEventListener('click',function(e){
    var o=e.target.closest('[data-cart-open]');
    if(o&&K.tpl!=='cart'){ e.preventDefault(); holen().then(function(c){ zeichne(c); window.openCart(); }); return; }
    if(e.target.closest('[data-cart-close]')){ window.closeCart(); return; }
    var ad=e.target.closest('[data-add-id]'); if(ad){ e.preventDefault(); window.addToCart(ad.getAttribute('data-add-id'),1,ad); return; }
    var qb=e.target.closest('#clines [data-key]'); if(qb){ aendern(qb.dataset.key,+qb.dataset.q); }
  });
  document.addEventListener('keydown',function(e){ if(e.key==='Escape') window.closeCart(); });
  var note=document.getElementById('cnote');
  if(note) note.addEventListener('change',function(){ fetch(K.routes.cartUpdate+'.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({note:note.value})}); });
  window.addEventListener('pageshow',function(){ if(window.fetch&&K.routes) holen().then(zeichne).catch(function(){}); });
  if(window.fetch&&K.routes) holen().then(zeichne).catch(function(){});
})();

/* ===================== Sorten-Karten (Start und Shop) ===================== */
(function(){
  document.querySelectorAll('.ware[data-sorte]').forEach(function(card){
    var dEl=card.querySelector('[data-daten]'); if(!dEl) return;
    var daten; try{ daten=JSON.parse(dEl.textContent); }catch(e){ return; }
    var cur=daten.start; var K=window.KOYI||{};
    var pEl=card.querySelector('[data-preis]'), proEl=card.querySelector('[data-pro]'), pfl=card.querySelector('[data-pflicht]'),
        add=card.querySelector('[data-wadd]'), mehr=card.querySelector('[data-wmehr]'), bild=card.querySelector('[data-wbild]'), bl=card.querySelector('[data-wbildlink]'),
        titel=card.querySelector('h2 a');
    var fmt=function(c){ return (window.koyiMoney?window.koyiMoney(c):(c/100).toFixed(2)); };
    function zeichne(){
      var d=daten[cur]; if(!d) return;
      pEl.textContent=d.text;
      var drinks=Math.floor(d.ml*10/28); proEl.textContent=fmt(Math.round(d.preis/drinks))+' pro Drink · ca. '+drinks+' Drinks';
      pfl.innerHTML=d.ml+' ml · 70\u00a0% vol · Grundpreis '+fmt(Math.round(d.preis/d.ml*1000))+' / l<br>inkl. MwSt., zzgl. <a href="/policies/shipping-policy">Versand</a> · ab 60\u00a0€ versandkostenfrei<br>Abgabe nur an Personen ab 18 Jahren';
      add.textContent=d.ok?('In den Warenkorb · '+d.text):'Ausverkauft'; add.disabled=!d.ok;
      if(mehr) mehr.href=d.url; if(titel) titel.href=d.url; if(bl) bl.href=d.url;
      if(bild&&!bild.hasAttribute('data-fest')&&d.bild){ bild.src=d.bild; }
      card.querySelectorAll('.wgroesse button').forEach(function(b){ b.classList.toggle('on',b.dataset.size===cur); });
    }
    card.querySelectorAll('.wgroesse button[data-size]').forEach(function(b){
      b.addEventListener('click',function(){ if(b.disabled||!daten[b.dataset.size]) return; cur=b.dataset.size; zeichne(); });
    });
    add.addEventListener('click',function(){ var d=daten[cur]; if(d&&d.ok) window.addToCart(d.id,1,add); });
    zeichne();
  });
})();

/* ===================== Produktseite ===================== */
(function(){
  var thumbs=document.querySelectorAll('.pdpthumb');
  thumbs.forEach(function(b){ b.addEventListener('click',function(){ var h=document.getElementById('pdpHaupt'); if(h){ h.src=b.dataset.bild; if(b.dataset.form) h.setAttribute('data-form',b.dataset.form); } thumbs.forEach(function(x){x.classList.toggle('on',x===b)}); }); });
  var f=document.getElementById('produktform');
  if(f&&window.fetch){ f.addEventListener('submit',function(e){ var idEl=f.querySelector('[name=id]'); if(!idEl) return; e.preventDefault(); window.addToCart(idEl.value,1,f.querySelector('[type=submit]')); }); }
  var sel=document.getElementById('varianten'), vd=document.getElementById('varianten-daten');
  if(sel&&vd){ var data={}; try{ data=JSON.parse(vd.textContent); }catch(e){} sel.addEventListener('change',function(){ var d=data[sel.value]; if(!d) return; var p=document.getElementById('pdpPreis'); if(p) p.textContent=d.preis; var k=document.getElementById('pdpKaufen'); if(k) k.textContent='In den Warenkorb · '+d.preis; }); }
})();

/* ===================== Suche ===================== */
(function(){
  var box=document.getElementById('suche'); if(!box) return;
  var inp=document.getElementById('sq'), res=document.getElementById('sergebnis'), t, K=window.KOYI||{routes:{search:'/search'}};
  function auf(){ box.hidden=false; setTimeout(function(){ inp.focus(); },30); }
  function zu(){ box.hidden=true; }
  document.addEventListener('click',function(e){
    if(e.target.closest('[data-search-open]')){ e.preventDefault(); auf(); return; }
    if(e.target.closest('[data-search-close]')||e.target===box) zu();
  });
  document.addEventListener('keydown',function(e){ if(e.key==='Escape') zu(); });
  function zeile(item,art){
    var a=document.createElement('a'); a.href=item.url;
    var im=item.image||(item.featured_image&&item.featured_image.url); if(im){ var i=document.createElement('img'); i.src=im; i.alt=''; i.width=48; i.height=60; a.appendChild(i); }
    var s=document.createElement('span'); s.textContent=item.title; var kl=document.createElement('small'); kl.textContent=art+(item.price?' · '+item.price:''); s.appendChild(kl); a.appendChild(s); return a;
  }
  inp.addEventListener('input',function(){
    clearTimeout(t); var q=inp.value.trim(); if(q.length<2){ res.innerHTML=''; return; }
    t=setTimeout(function(){
      fetch(K.routes.search+'/suggest.json?q='+encodeURIComponent(q)+'&resources[type]=product,article,page&resources[limit]=5',{headers:{Accept:'application/json'}})
        .then(function(r){return r.json()}).then(function(j){
          var r=(j.resources&&j.resources.results)||{}; res.innerHTML='';
          (r.products||[]).forEach(function(x){ res.appendChild(zeile(x,'Produkt')); });
          (r.articles||[]).forEach(function(x){ res.appendChild(zeile(x,'Journal')); });
          (r.pages||[]).forEach(function(x){ res.appendChild(zeile(x,'Seite')); });
          if(!res.children.length){ var p=document.createElement('p'); p.textContent='Nichts gefunden.'; p.className='txt'; res.appendChild(p); }
        }).catch(function(){});
    },250);
  });
})();
